import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    fileList: []
  },
  getters: {},
  mutations: {
    fileUpload(state, payload) {
      console.log(state, payload)
      state.fileList = payload.list
    },
  },
  actions: {
    // asyncIncrement(context) {
    //   // 模拟异步操作
    //   setTimeout(() => {
    //     // context.fileUpload('fileUpload');
    //   }, 1000);
    // },
  },
  modules: {}
})